import LoggerHelper from "@/plugins/LoggerHelper";
import UtilityHelper from "@/plugins/UtilityHelper";
import { i18n } from "@/i18n.js";

export default class EntityHelper {
  constructor(ctx) {
    this.ctx = ctx
  }

  setMasterDataState(myProperty,state)
  {
    this.clearMasterDataState();

    var masterDataState=this.ctx.$store.getters.masterDataState;
    masterDataState[myProperty]=state;
    this.ctx.$store.dispatch("setMasterDataState", masterDataState);
  }

  clearMasterDataState()
  {
    var masterDataState=this.ctx.$store.getters.masterDataState;
    for (var property in masterDataState) {
      if (Object.prototype.hasOwnProperty.call(masterDataState, property))
        masterDataState[property]=false;
    }
  }

  setUserState(state)
  {
    if (state)
    {
      //read customer data
      LoggerHelper.logEvent(LoggerHelper.levelInfo, i18n.global.t("logging.readUsers"), "");

      if (this.ctx.authorityHelper.hasRoleAdmin())
      {
        this.ctx.webService.getUsers(this.ctx.$store.getters.getUser)
          .then(response => {
            LoggerHelper.logEvent(LoggerHelper.levelInfo, i18n.global.t("logging.readUsersSuccess"), response.data);
            this.ctx.$store.dispatch("setUserList", response.data);
          })
          .catch(err => {
            LoggerHelper.logEvent(LoggerHelper.levelError, i18n.global.t("logging.readUsersFailed"), err);
          });
      }
      else
      {
        this.ctx.webService.getUser(this.ctx.$store.getters.getUser, this.ctx.$store.getters.user.username, this.ctx.$store.getters.selectedSAPClient)
          .then(response => {
            LoggerHelper.logEvent(LoggerHelper.levelInfo, i18n.global.t("logging.readUsersSuccess"), response.data);
            this.ctx.$store.dispatch("setUserList", [response.data]);
          })
          .catch(err => {
            LoggerHelper.logEvent(LoggerHelper.levelError, i18n.global.t("logging.readUsersFailed"), err);
          });
      }
    }
    this.setMasterDataState("showUser", state)
  }

  setDataTargetState(state)
  {
    if (state)
    {
      //read data targets
      LoggerHelper.logEvent(LoggerHelper.levelInfo, i18n.global.t("logging.readDataTargets"), "");
      this.ctx.webService.getDataTargets(this.ctx.$store.getters.getDataTargets)
        .then(response => {
          LoggerHelper.logEvent(LoggerHelper.levelInfo, i18n.global.t("logging.readDataTargetsSuccess"), response.data);
          this.ctx.$store.dispatch("setDataTargetList", response.data);
        })
        .catch(err => {
          LoggerHelper.logEvent(LoggerHelper.levelError, i18n.global.t("logging.readDataTargetsFailed"), err);
        });
    }
    this.setMasterDataState("showDataTarget", state)
  }

  setOrderState(state)
  {
    if (state)
    {
      //read orders
      LoggerHelper.logEvent(LoggerHelper.levelInfo, i18n.global.t("logging.readOrders", { logvar1: this.ctx.$store.getters.user.username }), "");
      this.ctx.webService.getOrders(this.ctx.$store.getters.getOrderEntrys,
        this.ctx.$store.getters.selectedSAPClient,
        this.ctx.$store.getters.user.username,
        new UtilityHelper(this.ctx).getSprCode()
        )
        .then(response => {
          LoggerHelper.logEvent(LoggerHelper.levelInfo, i18n.global.t("logging.readOrdersSuccess", { logvar1: this.ctx.$store.getters.user.username }), "");
          this.ctx.$store.dispatch("setOrderList", response.data);
        })
        .catch(err => {
          LoggerHelper.logEvent(LoggerHelper.levelError, i18n.global.t("logging.readOrdersFailed"), err);
        });
    }
    this.setMasterDataState("showOrder", state)
  }

  setPLState(state)
  {
    if (state)
    {
      var plConfig = {
        plTitle: i18n.global.t("message.plliste"),
        plIcon: 'md:analytics'
      }
      this.ctx.$store.dispatch("setPLConfig", plConfig);

      var plParameter = {
        sprcd: new UtilityHelper(this.ctx).getSprCode(),
        produktReihe: "%",
        glanzgrad: "%",
        struktur: "%",
        innenAussen: "%",
        farbton: "%",
        kdnnr: 0,
        sapClientId: this.ctx.$store.getters.selectedSAPClient
      };

      //read PL data
      LoggerHelper.logEvent(LoggerHelper.levelInfo, i18n.global.t("logging.readPowderCoatings"), plParameter);
      this.ctx.webService.getPLListByParameter(this.ctx.$store.getters.getPLByParameter, plParameter)
        .then(response => {
          LoggerHelper.logEvent(LoggerHelper.levelInfo, i18n.global.t("logging.readPowderCoatingsSuccess"), response.data);

          this.ctx.$store.dispatch(
            "setPLList",
            response.data.map((item, index) => ({
              id: index,
              ...item
            }))
          );          
        })
        .catch(err => {
          LoggerHelper.logEvent(LoggerHelper.levelError, i18n.global.t("logging.readPowderCoatingsFailed"), err);
        });
    }
    this.setMasterDataState("showPL", state)
  }

  setCustomerWarehouseState(state)
  {
    if (state)
    {
      this.ctx.$store.dispatch("setKdnnrCustomerWarehouse", 0);

      var plConfig = {
        plTitle: i18n.global.t("message.plCustomerWarehouse"),
        plIcon: 'mdi-hexagon-slice-6'
      }
      this.ctx.$store.dispatch("setPLConfig", plConfig);

      var plParameter = {
        sprcd: new UtilityHelper(this.ctx).getSprCode(),
        produktReihe: "%",
        glanzgrad: "%",
        struktur: "%",
        innenAussen: "%",
        farbton: "%",
        kdnnr: this.ctx.$store.getters.user.kdnnr,
        sapClientId: this.ctx.$store.getters.selectedSAPClient
      };

      //read Customer Warehouse data
      LoggerHelper.logEvent(LoggerHelper.levelInfo, i18n.global.t("logging.readPowderCoatings"), plParameter);
      this.ctx.webService.getPLListByParameter(this.ctx.$store.getters.getPLByParameter, plParameter)
        .then(response => {
          LoggerHelper.logEvent(LoggerHelper.levelInfo, i18n.global.t("logging.readPowderCoatingsSuccess"), response.data);

          this.ctx.$store.dispatch(
            "setPLList",
            response.data.map((item, index) => ({
              id: index,
              ...item
            }))
          );          
        })
        .catch(err => {
          LoggerHelper.logEvent(LoggerHelper.levelError, i18n.global.t("logging.readPowderCoatingsFailed"), err);
        });
    }
    this.setMasterDataState("showCustomerWarehouse", state)
  }

}
